import {ISlsOrd} from "../kova/slsordClient";


export function getCameraPrefixForSlsOrd(slsOrd:ISlsOrd) {
    return `b${slsOrd.blockNumber}l${slsOrd.lotNumber}_`;
}


